/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { c as call } from '../../index.es-142c5680.js';
import { a as adapterApiCall } from '../../bridge-adpter-api-0316c034.js';
import '../../tslib.es6-e01eabb2.js';

/**
 * Nebula容器调用。
 * 跟promiseNebula的区别，NBCall配合uni-api的extend机制，自动添加了success和fail的能力。
 * 支付宝SDK：https://smallfish.antfin-inc.com/jsapi/index.html
 */
function NBCall() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var apiName = args[0], params = args[1], successFormatOptions = args[2], errFormatOptions = args[3];
    adapterApiCall({
        apiName: apiName,
        params: params,
        JSCall: call,
        successFormatOptions: successFormatOptions,
        errFormatOptions: errFormatOptions,
    });
}

export { NBCall };
